/**
 * @param storeState
 * @returns {{}|import('../reducers/operator.js').OperatorInfo}
 */
export const getOperatorInfo = (storeState) => {
  const currentOperatorId = storeState.operators.currentOperatorId;

  if (currentOperatorId) {
    return storeState.operators[currentOperatorId];
  }

  return {
    first_name: 'SiteGround',
    last_name: 'Chat'
  };
};

/**
 * @param storeState
 * @returns {boolean} operatorIsTyping
 */
export const getOperatorTypingStatus = (storeState) => storeState.operators.operatorIsTyping;

export const getLanguagesMapping = (storeState) => storeState.operators.languages;
